export default __webpack_public_path__ + "static/media/proam_banner.03993c99.png";